<template>
  <v-app>
    <barion-pixel />

    <default-bar />

    <default-drawer />

    <default-view />

    <default-footer />

    <default-settings v-if="false" />

    <modal-idle v-if="isIdle" />
  </v-app>
</template>

<script>
  // import { dispatch } from 'vuex-pathify'
  import ModalIdle from '@/components/ModalIdle'
  import BarionPixel from '@/layouts/default/BarionPixel'

  export default {
    name: 'DefaultLayout',

    components: {
      BarionPixel,
      ModalIdle,
      DefaultBar: () => import(
        /* webpackChunkName: "default-app-bar" */
        './AppBar'
      ),
      DefaultDrawer: () => import(
        /* webpackChunkName: "default-drawer" */
        './Drawer'
      ),
      DefaultView: () => import(
        /* webpackChunkName: "default-view" */
        './View'
      ),
      DefaultFooter: () => import(
        /* webpackChunkName: "default-footer" */
        './Footer'
        ),
      DefaultSettings: () => import(
        /* webpackChunkName: "default-settings" */
        './Settings'
        ),
    },
    computed: {
      isIdle () {
        return this.$store.state.idleVue.isIdle
      },
    },
    created () {
      // dispatch('auth/check')
      // dispatch('auth/checkProfile')
    },
  }
</script>
